var detectFontSize = function detectFontSize(el, startFontSize, step) {
  var clientWidth = el.clientWidth,
      scrollWidth = el.scrollWidth;
  var size = clientWidth < scrollWidth ? startFontSize - step : startFontSize;
  el.style.fontSize = "".concat(size, "px");
  return size;
};

var adjustFontSize = function adjustFontSize(el, startFontSize, step) {
  var currentSize = startFontSize;
  el.style.fontSize = "".concat(currentSize, "px");
  var size = detectFontSize(el, currentSize, step);

  for (var i = 0; i <= startFontSize * 2; i++) {
    currentSize = size;
    size = detectFontSize(el, currentSize, step);

    if (size === currentSize) {
      break;
    }
  }

  return size;
};

var afontsize = (function (el) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    min: 0,
    max: 9000
  },
      min = _ref.min,
      max = _ref.max;

  var _ref2 = "".concat(parseInt(max)),
      length = _ref2.length;

  var size = null;

  for (var i = length; i >= 1; i--) {
    var step = Math.pow(10, i - 1);
    var startSize = size === null ? max : size + step * 10;

    if (startSize > max) {
      startSize = max / step;
    }

    size = adjustFontSize(el, startSize, step);
  }

  if (min !== undefined && size < min) {
    size = min;
    el.style.fontSize = "".concat(size, "px");
  }

  return size;
});

export default afontsize;
//# sourceMappingURL=afontsize.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/afontsize/es/afontsize.js
// module id = 348
// module chunks = 0